import { Card, Modal } from '@opengov/component-library/dist';
import React from 'react';

import { IReportLocale } from '../../../../common/locale';

import { BasicCalculationIcon } from './BasicCalculationIcon';
import { ConditionalIcon } from './ConditionalIcon';
import styles from './CreateCalculationModal.scss';

export interface ICreateCalculationMsgs {
  title: string;
}

export interface ICreateCalculationModal {
  reportLocaleText: IReportLocale;
  userCanCreateBasicCalculation: boolean;
  userCanCreateConditional: boolean;
  onCalculationTypeSelect(calculationType: string): void;
  closeModal(): void;
}

export const CreateCalculationModal: React.FC<ICreateCalculationModal> = (props) => {
  const {
    reportLocaleText: {
      calculations: {
        createCalculationModal: {
          calculate,
          createNewColumn,
          calculateDescription,
          conditional,
          conditionalDescription
        }
      }
    },
    userCanCreateBasicCalculation,
    userCanCreateConditional,
    onCalculationTypeSelect
  } = props;

  return (
    <Modal.Work title={createNewColumn} onClose={props.closeModal}>
      <div className={styles.cardRow}>
        {userCanCreateBasicCalculation && (
          <Card.Basic
            dataTest="basic-calculation-card"
            onClick={() => {
              onCalculationTypeSelect('calculate');
            }}
            title={calculate}
            content={calculateDescription}
            icon={<BasicCalculationIcon />}
          />
        )}
        {userCanCreateBasicCalculation && userCanCreateConditional ? <div className={styles.cardSpacer} /> : <div />}
        {userCanCreateConditional && (
          <Card.Basic
            dataTest="conditional-card"
            onClick={() => {
              onCalculationTypeSelect('conditional');
            }}
            title={conditional}
            content={conditionalDescription}
            icon={<ConditionalIcon />}
          />
        )}
      </div>
    </Modal.Work>
  );
};
